// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__FeLL_","upload":"Small_upload__3wzPK","imageWrap":"Small_imageWrap__2h7cM","removeBtn":"Small_removeBtn__1KBO-"};